import styled from "styled-components";
import { typographyMixin } from "../../typography";

export const StyledLeader = styled.div`
  ${typographyMixin}
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 1rem;
`;

export const Category = styled.div`
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
  width: 50px;
`;

export const Title = styled.div`
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
  text-align: center;
`;

export const Value = styled.div`
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
  text-align: right;
  width: 50px;
`;

export const StyledLeaderList = styled.div`
display: flex;
flex-direction: column;

> div:nth-child(odd) {
    background-color: #F5F5F5;
  }
`